"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.postEmailSend = exports.getEmailSendingList = exports.getEmailById = void 0;
var core_1 = __importDefault(require("@/api/core"));
var getEmailById = function (_a) {
    var notificationId = _a.notificationId;
    return core_1.default.get({
        url: "/email/".concat(notificationId),
    });
};
exports.getEmailById = getEmailById;
var getEmailSendingList = function (params) {
    return core_1.default.get({
        url: '/email',
        params: params,
    });
};
exports.getEmailSendingList = getEmailSendingList;
var postEmailSend = function (_a) {
    var applicationIds = _a.applicationIds, memo = _a.memo, templateName = _a.templateName;
    return core_1.default.post({
        url: "/email/send",
        data: {
            applicationIds: applicationIds,
            memo: memo,
            templateName: templateName,
        },
    });
};
exports.postEmailSend = postEmailSend;
